import { render, staticRenderFns } from "./StartButton.vue?vue&type=template&id=6cba8e55&scoped=true&"
import script from "./StartButton.vue?vue&type=script&lang=ts&"
export * from "./StartButton.vue?vue&type=script&lang=ts&"
import style0 from "./StartButton.vue?vue&type=style&index=0&id=6cba8e55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba8e55",
  null
  
)

export default component.exports